var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewedMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "118px",
    viewBox: "0 0 128 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Page/Viewed Me") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Favorite-&-Viewed-me-\\uD83D\\uDC95",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Viewed-Me---Empty",
    transform: "translate(-131.000000, -213.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Page/Viewed-Me",
    transform: "translate(51.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blocked-members-empty-icon",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(83.391304, 40.573333)",
    stroke: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1247476,0 C62.289737,0 75.3940502,13.1504687 75.3940502,29.372394 C75.3940502,39.5565448 70.2291836,48.5301275 62.3846327,53.7992065 C78.7432006,60.3184736 90.4495057,76.0667556 91.1237206,94.6400392 L3.20877629e-05,94.6400392 C0.684074607,75.7960258 12.7241654,59.8599704 29.4571019,53.5185446 C21.8417904,48.2168645 16.8554449,39.378992 16.8554449,29.372394 C16.8554449,13.1504687 29.9597581,0 46.1247476,0 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M170.356522,88.3066667 C186.147063,88.3066667 198.947826,101.129231 198.947826,116.946667 C198.947826,123.754658 196.576443,130.007839 192.615956,134.922601 L207.924909,150.37629 L203.696781,154.579039 L188.41435,139.15261 C183.491043,143.174732 177.204972,145.586667 170.356522,145.586667 C154.56598,145.586667 141.765217,132.764102 141.765217,116.946667 C141.765217,101.129231 154.56598,88.3066667 170.356522,88.3066667 Z M170.356522,94.2733333 C157.855676,94.2733333 147.721739,104.42453 147.721739,116.946667 C147.721739,129.468803 157.855676,139.62 170.356522,139.62 C175.567925,139.62 180.367978,137.8558 184.193949,134.891089 L184.133352,134.830377 L188.361479,130.627628 L188.388628,130.653252 C191.276933,126.84639 192.991304,122.097076 192.991304,116.946667 C192.991304,104.42453 182.857367,94.2733333 170.356522,94.2733333 Z",
    id: "Combined-Shape",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 170.356522,
    cy: 116.946667,
    rx: 22.6347826,
    ry: 22.6733333
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewedMe);
export default __webpack_public_path__ + "static/media/viewed-me.afb528fb8f1b3842aaa959e97c7a2977.svg";
export { ForwardRef as ReactComponent };